import { IconButton, Typography, Link, Dialog, DialogTitle, DialogContent } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import { ModuleItemBox } from '../FolderModule.styles';
import { theme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../../../components/common/DefaultIcon';
import { defaultIcon } from '../../ServiceModulesContainer';
import { GeneralButton } from '../../../../common/ui/GeneralButton';

type Props = {
  name: string;
  url: string;
  type: string;
  iconName: string;
  iconUrl: string | null;
  colorHex: string | null;
  onDelete: () => void;
  onEdit: () => void;
};

const UrlCard = ({ name, url, type, iconName, iconUrl, colorHex, onEdit, onDelete }: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false);

  const handleModuleClick = () => {
    setOpen(true);
  };

  const handleEditClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEdit();
  };

  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDelete();
  };

  return (
    <>
      <ModuleItemBox onClick={handleModuleClick}>
        <DefaultIcon
          iconName={iconName ?? defaultIcon(type)}
          colorHex={colorHex ?? theme.palette.primary.main}
          iconUrl={iconUrl}
        />
        <Typography sx={{ flexGrow: 1, marginLeft: 2 }}>{name}</Typography>
        <IconButton onClick={handleEditClick}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={handleDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </ModuleItemBox>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{name}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom>URL:</Typography>
          {url ? (
            <Link href={url} target="_blank" rel="noopener noreferrer">
              <Typography variant="body2" paragraph>{url}</Typography>
            </Link>
          ) : (
            <Link href="https://www.bonisoft.de/" target="_blank" rel="noopener noreferrer">
              <Typography variant="body2" paragraph>({t("serviceModulesPage.folderServicePage.noUrl")})</Typography>
            </Link>
          )}
        </DialogContent>
        <GeneralButton
          appVariant="secondary"
          onClick={() => setOpen(false)}
        >
          {t("buttons.close")}
        </GeneralButton>
      </Dialog>
    </>
  );
};

export default UrlCard;
